<template>
  <div class="dflexc-jcs merchant-stat-card">
    <div class="dflexr-jcsb stat-row">
      <span class="stat-lbl">
        Str:
      </span> {{ merchant.stats.str }}
    </div>

    <div class="dflexr-jcsb stat-row">
      <span class="stat-lbl">
        Int:
      </span> {{ merchant.stats.int }}
    </div>

    <div class="dflexr-jcsb stat-row">
      <span class="stat-lbl">
        Dex:
      </span> {{ merchant.stats.dex }}
    </div>
  </div>
</template>

<style scoped lang="scss">
  .merchant-stat-card {
    width: 40px;
    height: 90px;
    border: 1px solid black;
    margin: 1.3rem 1rem;
    border-radius: 1rem;
    padding: .2rem .4rem;
    text-align: left;

    .stat-lbl {
      font-size: .6rem;
      vertical-align: top;
    }
  }
</style>

<script setup>

import {onBeforeMount, onMounted, onUpdated} from "vue";

const props = defineProps(['merchant'])

onBeforeMount(function () {
})

onMounted(function () {
})

onUpdated(function () {
})

</script>
